var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imagePopup"},[_c('van-popup',{attrs:{"value":_vm.value},on:{"input":function (val){ return this$1.$emit('input',val); }}},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":"头像预览"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }